import { z } from 'zod';
// Request and response schemas for the API layer
export const AssignPersonToCompanyRequestDTOSchema = z.object({
    body: z.object({
        personId: z.string().uuid(),
    }),
    params: z.object({
        companyId: z.string().uuid(),
    }),
});
//# sourceMappingURL=assign-person-to-company.dto.js.map